<template>
  <div id="contenedor-responsables-proyecto" class="mt-4">
    <v-row>
      <template
        v-for="responsable in listadoProyectoResponsables">
        <template>
          <v-col
            cols="12"
            md="4"
            :key="responsable.id">
            <v-hover v-slot="{ hover }">
              <v-card
                outlined
                :elevation="hover ? 2 : 0">
                <div class="d-flex px-4 py-2 mt-1 align-top">
                  <div class="mr-3">
                    <Avatar
                      tipo="nombre"
                      :nombre="responsable.funcionario.nombre"
                      :img-url="getUsuarioAvatar(responsable.funcionario.usuario)"
                      color="grey lighten-2"
                      :size="38">
                    </Avatar>
                  </div>
                  <div class="subtitle-1">
                    <span class="font-weight-medium">
                      {{ responsable.funcionario.nombre }}
                    </span>
                    <v-tooltip top v-if="responsable.esLider">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        size="20"
                        color="amber darken-2"
                        v-bind="attrs"
                        v-on="on">
                        mdi-star-circle
                      </v-icon>
                    </template>
                    <span>Líder del Proyecto</span>
                  </v-tooltip>
                    <span class="d-block text--secondary caption">
                      {{ responsable.funcionario.puesto }}
                    </span>
                  </div>
                  <v-spacer></v-spacer>
                  <div v-if="validarUsuarioLider" class="d-flex">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-show="hover"
                          icon
                          v-bind="attrs"
                          v-on="on"
                          @click="eliminarResponsable(responsable)">
                          <v-icon small>
                            mdi-close
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>Remover responsable</span>
                    </v-tooltip>
                  </div>
                </div>
                <v-card-text>
                  <div class="d-flex">
                    <div>
                      <v-chip
                        small
                        pill
                        :color="responsable.fechaValido ? 'success' : 'warning'">
                        <template
                          v-if="responsable.fechaValido">
                          <v-icon small left>
                            mdi-check
                          </v-icon>
                          Validado el:
                          {{ new Date(responsable.fechaValido).toLocaleDateString() }}
                          {{ new Date(responsable.fechaValido).toLocaleTimeString() }}
                        </template>
                        <template
                          v-else>
                          Sin validar
                        </template>
                      </v-chip>
                      <v-btn
                        v-if="responsable.funcionario.usuario
                          && responsable.funcionario.usuario.id == $auth.user.id
                          && responsable.fechaValido === null"
                        text
                        rounded
                        small
                        color="success"
                        class="custom-transform-class text-none caption"
                        @click="mixValidarProyectoResponsable(responsable.id)">
                        <v-icon small left>
                          mdi-check
                        </v-icon>
                        Validar
                      </v-btn>
                    </div>
                    <v-spacer></v-spacer>
                    <div>
                      <span class="caption">
                        <v-icon x-small class="mr-1">
                          mdi-clock-alert-outline
                        </v-icon>
                        <FechaHumano
                          :fecha="responsable.createdAt">
                        </FechaHumano>
                      </span>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-hover>
          </v-col>
        </template>
      </template>
    </v-row>
    <v-dialog
      v-if="esteResponsable"
      v-model="mostrarEliminarResponsableProyecto"
      width="400">
      <eliminar-responsable-proyecto
      :proyectoResponsableEliminar="esteResponsable"
      v-on:cerrar="cerrarEliminarResponsable">
      </eliminar-responsable-proyecto>
    </v-dialog>
  </div>
</template>

<script>
import FechaHumano from '@/components/FechaHumano.vue';
import Avatar from '@/components/Avatar.vue';
import mixProyectoResponsables from '../mixProyectosResponsables';
import EliminarResponsableProyecto from '../Eliminar.vue';

export default {
  name: 'ListadoResponsablesProyecto',
  mixins: [mixProyectoResponsables],
  props: {
    idProyecto: {
      type: String,
      required: true,
    },
  },
  components: {
    Avatar,
    FechaHumano,
    EliminarResponsableProyecto,
  },
  data() {
    return {
      mostrarEliminarResponsableProyecto: false,
      esteResponsable: null,
    };
  },
  methods: {
    getUsuarioAvatar(usuario) {
      if (!usuario) return null;
      if (!usuario?.avatarPublicKey) return null;
      return `${this.$urlFileServer}/${usuario?.avatarPublicKey}`;
    },
    eliminarResponsable(responsable) {
      this.esteResponsable = responsable;
      this.mostrarEliminarResponsableProyecto = true;
    },
    cerrarEliminarResponsable() {
      this.mostrarEliminarResponsableProyecto = false;
      this.esteResponsable = null;
    },
  },
  computed: {
    listadoProyectoResponsables() {
      if (!this.proyectoResponsables) return [];
      return this.proyectoResponsables;
    },
    getLideres() {
      if (!this.proyectoResponsables) return [];
      const lideres = this.proyectoResponsables
        .slice()
        .filter((proyectoResponsables) => proyectoResponsables.esLider);
      return lideres;
    },
    validarUsuarioLider() {
      const lideresUsuarioIds = this.getLideres
        .slice()
        .map((lider) => lider.funcionario.usuario?.id);

      return lideresUsuarioIds.includes(this.$auth.user.id);
    },
  },
};
</script>

<style lang="scss">

</style>
